import { UnreadComment } from '@sweep-io/sweep-design/dist/icons/UnreadComment';
import { useConfigurationCanvasContext } from '../../../configuration-canvas/ConfigurationCanvasContext';
import { CanvasToolbarButton } from './CanvasToolbarButton';
import { useCanvasToolbarContext } from './CanvasToolbarCtx';
import { useCallback, useEffect } from 'react';

export const CommentsButton = ({ isDisabled }: { isDisabled?: boolean }) => {
  const { setCommentsOn, commentsOn } = useConfigurationCanvasContext();
  const { activeExclusiveButton, setActiveExclusiveButton } = useCanvasToolbarContext();

  // Deactivate comments when another exclusive button is activated
  useEffect(() => {
    if (activeExclusiveButton !== 'comments' && commentsOn) {
      setCommentsOn(false);
    }
    if (activeExclusiveButton === 'comments' && !commentsOn) {
      setActiveExclusiveButton(null);
    }
  }, [activeExclusiveButton, setCommentsOn, commentsOn, setActiveExclusiveButton]);

  const handleToggle = useCallback(
    (pressed: boolean) => {
      if (pressed) {
        setCommentsOn(true);
        setActiveExclusiveButton('comments');
      } else {
        setCommentsOn(false);
        setActiveExclusiveButton(null);
      }
    },
    [setActiveExclusiveButton, setCommentsOn],
  );

  return (
    <CanvasToolbarButton
      tooltip="Comments"
      onToggle={handleToggle}
      pressed={commentsOn}
      disabled={isDisabled}
    >
      <UnreadComment />
    </CanvasToolbarButton>
  );
};
